import app from 'flarum/forum/app';
import TextSelectionTrigger from './components/TextSelectionTrigger';
import AgentDockPanel from './components/AgentDockPanel';
import SarahDailyTipNotification from './components/SarahDailyTipNotification';
import SarahLevelUpNotification from './components/SarahLevelUpNotification';
import { flush as flushArchive } from './utils/SarahArchiver';

// ============================================================
// 萨拉 AI · 论坛端入口
//
// AgentDockPanel 多标签容器：内置萨拉对话 + 扩展注册标签
// （taro-case 等通过 app.taroAgentTabs.register 注册新标签）
// ============================================================

app.sarahAi = {
  panelOpen: false,
  initialQuery: '',
  conversationId: null,
  fromSelection: false,
};

// ---------- Agent 标签注册表（防御式：两扩展 bundle 加载顺序不定）----------
if (!app.taroAgentTabs) {
  app.taroAgentTabs = {
    _tabs: [],
    register(tab) {
      if (tab && tab.id && tab.component) {
        if (!this._tabs.find((t) => t.id === tab.id)) {
          this._tabs.push(tab);
        }
      }
    },
  };
}

let mounted = false;

function mountUI() {
  if (mounted) return;
  mounted = true;

  try {
    // Agent 停靠面板（多标签容器：萨拉 + 扩展注册标签）
    let panelWrap = document.querySelector('.SarahPanel-wrapper');
    if (!panelWrap) {
      panelWrap = document.createElement('div');
      panelWrap.className = 'SarahPanel-wrapper';
      const dock =
        document.querySelector('.TaroShell-agentSheetBody') ||
        document.getElementById('taro-shell-agent');
      (dock || document.body).appendChild(panelWrap);
    }
    try { m.mount(panelWrap, AgentDockPanel); } catch (e) { console.warn('[taro-ai] AgentDockPanel mount failed:', e); }
  } catch (e) { console.warn('[taro-ai] AgentDockPanel setup failed:', e); }

  try {
    let selWrap = document.querySelector('.TextSelectionTrigger-wrapper');
    if (!selWrap) {
      selWrap = document.createElement('div');
      selWrap.className = 'TextSelectionTrigger-wrapper';
      document.body.appendChild(selWrap);
    }
    try { m.mount(selWrap, TextSelectionTrigger); } catch (e) { console.warn('[taro-ai] TextSelectionTrigger mount failed:', e); }
  } catch (e) { console.warn('[taro-ai] TextSelectionTrigger setup failed:', e); }
}

// ---------- 每日建议 ----------
function checkDailyTip() {
  try {
    if (!app.session?.user) return;
    const userId = app.session.user.id();
    const today = new Date().toISOString().slice(0, 10);
    const key = 'sarah_daily_tip_' + userId + '_' + today;
    try { if (localStorage.getItem(key)) return; localStorage.setItem(key, '1'); } catch (_) {}

    app.request({
      url: app.forum.attribute('apiUrl') + '/taro/ai/daily-tip',
      method: 'POST',
      body: { data: { attributes: {} } },
    }).catch(function() {});
  } catch (_) {}
}

app.initializers.add('taro-ai', () => {
  // ── 通知组件注册 ──
  app.notificationComponents.sarahDailyTip = SarahDailyTipNotification;
  app.notificationComponents.sarahLevelUp = SarahLevelUpNotification;

  // ── 挂载 UI（延迟到 DOM ready）──
  setTimeout(function() {
    mountUI();
    checkDailyTip();
  }, 200);

  // ── 归档 flush ──
  try { flushArchive(app.session.user ? app.session.user.id() : null); } catch (_) {}
});
